/**
 * Reaction configuration - TypeScript wrapper around shared constants
 * 
 * This file imports from the single source of truth (shared/constants/reactions.js)
 * and provides TypeScript types and additional utilities.
 */

// Import from single source of truth (CommonJS module)
// eslint-disable-next-line @typescript-eslint/no-var-requires
const reactionsModule = require('../constants/reactions.js');

// Re-export with proper TypeScript types
export const REACTION_EMOJIS: readonly string[] = reactionsModule.REACTION_EMOJIS;

export interface ReactionMeta {
  label: string;
  category: 'standard' | 'emphasis' | 'action' | 'business';
  shortcut?: string;
}

export const REACTION_META: Record<string, ReactionMeta> = reactionsModule.REACTION_META;

/**
 * Get reaction label by emoji
 */
export function getReactionLabel(emoji: string): string {
  return reactionsModule.getReactionLabel(emoji);
}

/**
 * Validate if an emoji is a valid reaction type
 */
export function isValidReaction(emoji: string): boolean {
  return reactionsModule.isValidReaction(emoji);
}

/**
 * Group reactions by category
 */
export function getReactionsByCategory(category: ReactionMeta['category']): string[] {
  return reactionsModule.getReactionsByCategory(category);
}

/**
 * Type for valid reaction emojis
 * Note: This is a string type since the actual values come from runtime.
 * For strict type checking, use isValidReaction() function.
 */
export type ReactionEmoji = string;
